import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../thema/style";
import ProductItem from "./ProductItem";
import activeDiscount from "../helpers/activeDiscount";
import calculatePrice from "../helpers/calculatePrice";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../config";

import Loading from "./shared/Loading";
import { connect } from "react-redux";
import { recentlyAddedProducts } from "../store/actions/product";
import CartItem from "./CartItem";

class OrderDetailProducts extends Component {
  // products;
  // this.props.order.order.products
  render() {
    // return "ASD";console.log()
    const cartTotalDiscountPrice =
      this.props.products.length > 0
        ? parseFloat(
            this.props.products
              .map((product) => {
                return product.categories
                  ? parseFloat(
                      calculatePrice(
                        product,
                        activeDiscount(product.categories)
                      )
                    )
                  : 0;
              })
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    const cartTotalPrice =
      this.props.products.length > 0
        ? parseFloat(
            this.props.products
              .map((item) => {
                return item.salePrice
                  ? item.quantity * item.salePrice
                  : item.quantity * item.price;
              })
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    console.log(
      "xxcartTotalDiscountPrice,cartTotalPrice",
      cartTotalDiscountPrice,
      cartTotalPrice
    );

    return (
      <table
        className={"table table-bordered table-hover order-detail"}
        style={{ marginTop: 20 }}
      >
        <thead>
          <tr>
            <th>Ürün Resmi</th>
            <th>Ürün Adı</th>
            <th>Miktarı</th>
            <th>Birim Fiyatı</th>
            <th>Toplam</th>
          </tr>
        </thead>

        <tbody>
          {this.props.order[
            this.props.customer ? "order" : "orderEnquiry"
          ].products.map(({ product, quantity, price }, i) =>
            !product ? (
              <tr>
                <td className={"text-center"}>
                  <Link to={`#`}>
                    <img
                      src={"/images/no-product.png"}
                      style={{ width: 120 }}
                    />
                  </Link>
                </td>
                <td>
                  <Link to={`#`}>Ürün kaldırılmış olabilir.</Link>
                </td>
                <td>{quantity}</td>
                <td>₺0</td>
                <td>₺{price}</td>
              </tr>
            ) : (
              <tr key={i}>
                <td className={"text-center"}>
                  <Link
                    to={{
                      pathname: `/urun/${product.slug}`,
                      // state: { product: this.props.product },
                    }}
                  >
                    <img
                      style={{ width: 120 }}
                      alt={product.name}
                      src={PUBLIC_URL(product.image)}
                    />
                  </Link>
                </td>
                <td>
                  <Link
                    to={{
                      pathname: `/urun/${product.slug}`,
                      // state: { product: this.props.product },
                    }}
                  >
                    {product.name}
                  </Link>
                </td>
                <td>{quantity}</td>
                <td>
                  <span
                    style={{
                      color: activeDiscount(product.categories)
                        ? "#ccc"
                        : "#000",
                      textDecoration: activeDiscount(product.categories)
                        ? "line-through"
                        : "none",
                    }}
                  >
                    ₺
                    {product.sale_price
                      ? parseFloat(product.sale_price).toFixed(2)
                      : parseFloat(product.price).toFixed(2)}
                  </span>
                  {activeDiscount(product.categories) ? (
                    <React.Fragment>
                      <br />₺
                      {activeDiscount(product.categories).type === "percent"
                        ? product.sale_price
                          ? parseFloat(
                              product.sale_price *
                                (1 -
                                  activeDiscount(product.categories).discount /
                                    100)
                            ).toFixed(2)
                          : parseFloat(
                              product.price *
                                (1 -
                                  activeDiscount(product.categories).discount /
                                    100)
                            ).toFixed(2)
                        : product.sale_price
                        ? parseFloat(
                            product.sale_price -
                              activeDiscount(product.categories).discount
                          ).toFixed(2)
                        : parseFloat(
                            product.price -
                              activeDiscount(product.categories).discount
                          ).toFixed(2)}
                    </React.Fragment>
                  ) : null}
                </td>
                <td>₺{price}</td>
              </tr>
            )
          )}
        </tbody>
        <tfoot>
          <tr>
            <td className={"text-right"} colSpan={4}>
              <strong>Ara Toplam:</strong>
            </td>
            <td className={"text-center"}>
              ₺{parseFloat(cartTotalPrice).toFixed(2)}
            </td>
          </tr>

          {cartTotalDiscountPrice > 0 ? (
            <tr>
              <td className={"text-right"} colSpan={4}>
                <strong>Kargo:</strong>
              </td>
              <td className={"text-center"}>
                ₺
                {parseFloat(this.props.setting.setting.shipping_cost).toFixed(
                  2
                )}
              </td>
            </tr>
          ) : null}

          {cartTotalDiscountPrice >=
          this.props.setting.setting.free_shipping ? (
            <tr>
              <td className={"text-right"} colSpan={4}>
                <strong>
                  {parseFloat(this.props.setting.setting.free_shipping).toFixed(
                    2
                  )}{" "}
                  TL ve Üzeri Ücretsiz Kargo
                </strong>
              </td>
              <td className={"text-center"} style={{ color: "rgb(205 26 52)" }}>
                -₺
                {parseFloat(this.props.setting.setting.shipping_cost).toFixed(
                  2
                )}
              </td>
            </tr>
          ) : null}

          {cartTotalPrice - cartTotalDiscountPrice > 0 ? (
            <tr>
              <td className={"text-right"} colSpan={4}>
                <strong>Sepette İndirim</strong>
              </td>
              <td className={"text-center"} style={{ color: "rgb(205 26 52)" }}>
                -₺
                {parseFloat(cartTotalPrice - cartTotalDiscountPrice).toFixed(2)}
              </td>
            </tr>
          ) : null}

          <tr>
            <td className={"text-right"} colSpan={4}>
              <strong>Toplam:</strong>
            </td>
            <td className={"text-center"}>
              ₺
              {parseFloat(
                cartTotalDiscountPrice > 0
                  ? cartTotalDiscountPrice +
                      (cartTotalDiscountPrice >=
                      this.props.setting.setting.free_shipping
                        ? 0
                        : this.props.setting.setting.shipping_cost)
                  : 0
              ).toFixed(2)}
            </td>
          </tr>
          {(cartTotalDiscountPrice > 0
            ? cartTotalDiscountPrice +
              (cartTotalDiscountPrice >=
              this.props.setting.setting.free_shipping
                ? 0
                : this.props.setting.setting.shipping_cost)
            : 0) <= 0 ? (
            <tr>
              <td className="text-center" colSpan={5}>
                <small style={{ fontWeight: "600", color: "#900" }}>
                  Satın aldığınız ürünler kaldırılmış, fiyatı güncellenmiş yada
                  stoğu tükenmiş olabilir, bu nedenle görüntülenen bilgiler
                  doğru olmayabilir.
                </small>
              </td>
            </tr>
          ) : null}
        </tfoot>
      </table>
    );
  }
}

const mapStateToProps = ({ setting, cart }) => {
  return { setting, cart };
};

const mapDispatchToProps = {
  recentlyAddedProducts,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderDetailProducts);



// WEBPACK FOOTER //
// ./src/components/OrderDetailProducts.js